// extracted by mini-css-extract-plugin
export default {"header":"LeHzT4p9vpyKIPe2dGok","arrow":"N5hKRplD5uy0h8ddLoVH","arrowInverted":"mAt3BR1_FR1TjifUT7ei","content":"VTcDTH0fRsJXeSM1ANvv"};